var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CoolLightBox',{attrs:{"items":_vm.coolLightBoxItems,"index":_vm.coolLightBoxIndex,"srcName":"url","loop":true,"fullscreen":true},on:{"close":function($event){return _vm.setcoolLightBoxIndex(null)}}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }